import { memo, ReactNode } from 'react';

import { NodeTypes } from '@/src/modules/AutomationModuleNew/types/flowsTypes';

import AccordionRow from './AccordionRow';

export type AccordionNodesType = {
  label: string;
  children: ReactNode;
};

interface AccordionNodesProps {
  nodeTypes: Record<NodeTypes, AccordionNodesType>;
}

const AccordionNodes = ({ nodeTypes }: AccordionNodesProps) => {
  return (
    <div className="flex w-full flex-col">
      {nodeTypes &&
        Object.entries(nodeTypes).map(([nodeType, value]) => {
          const { label, children } = value;
          return (
            <AccordionRow key={nodeType} label={label}>
              {children}
            </AccordionRow>
          );
        })}
    </div>
  );
};

export default memo(AccordionNodes);
